import React from 'react';
import ListViewBody from './ListViewBody';
import ListViewCell from './ListViewCell';
import ListViewCellContent from './ListViewCellContent.jsx';
import ListViewColumn from './ListViewColumn';
import ListViewContents from './ListViewContents';
import { ListViewProvider } from './ListViewContext';
import ListViewEmpty from './ListViewEmpty';
import ListViewHeader from './ListViewHeader';
import ListViewLoader from './ListViewLoader';
import ListViewRow, { ListViewTotalRow } from './ListViewRow';
import Bar from './ListViewStatus';
import ListViewTotal from './ListViewTotal';

function ListView(props) {
  return (
    <ListViewProvider>
      <ListViewContents {...props} />
    </ListViewProvider>
  );
}

ListView.Header = ListViewHeader;
ListView.Column = ListViewColumn;
ListView.Body = ListViewBody;
ListView.Row = ListViewRow;
ListView.TotalRow = ListViewTotalRow;
ListView.Cell = ListViewCell;
ListView.CellContent = ListViewCellContent;
ListView.Total = ListViewTotal;
ListView.Status = Bar;
ListView.Loader = ListViewLoader;
ListView.Empty = ListViewEmpty;

export default ListView;
